import type { FormField } from '@cli-types/core-engine/schema.js'
import { inputClass } from './input-class.js'

export function selectClass(height?: FormField['height']): string {
  return inputClass(height)
}
